import {Component, Input, OnInit, SimpleChanges} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {FormBuilder} from '@angular/forms';
import {AppTranslateService} from 'src/app/modules/services/translate/app-translate.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-etat-general-four',
    templateUrl: './etat-general-four.component.html',
    styleUrls: ['./etat-general-four.component.css'],
})
export class EtatGeneralFourComponent implements OnInit {
    lavel = 'Informations  Détaillées Lot';
    @Input() dataa = [];
    dataSource: MatTableDataSource<any>;

    displayedColumns = [];
    labels = [
        'Catégorie',
        'Identifiant Unique',
        'Date Enregistrement Registre Commerce',
        // "N° Affiliation La C.N.S.S.",
        'Nom Société',
        'Nom Commercial',
        'Nationalité',
        'Date Ouverture',
        'Catégorie Activité',
        'Forme Juridique',
        'Capital Social',
        'Nombre Employés',
        'Code postal',
        'Adresse',
        'Adresse Détaillée',
        'N° Téléphone Fixe',
        'N° Fax',
        'Site Web',
        'Email Notification Résultat',
    ];
    @Input() list = [];
    dataColumns;
    @Input() info_gen = 'Informations Générales';
    checked = [];
    tes = false;
    items: any[] = [];
    public current_lang = this.apptranstlte.getDefaultLang();

    constructor(
        private formBuilder: FormBuilder,
        private apptranstlte: AppTranslateService,
        private translateS: TranslateService
    ) {
        translateS.onLangChange.subscribe(({lang}) => {
            this.current_lang = lang;
        });
    }

    ngOnInit(): void {
        this.checkLan();
        this.getInfopGDetails();
    }

    getInfopGDetails() {
        let transposedData = [];
        for (let column = 0; column < this.dataColumns.length; column++) {
            transposedData[column] = {
                label: this.labels[column],
            };
            for (let row = 0; row < this.dataa.length; row++) {
                transposedData[column][`column${row}`] = this.dataa[row][
                    this.dataColumns[column]
                    ];
            }
        }
        this.dataSource = new MatTableDataSource(transposedData);
        this.displayedColumns = ['label'];

        for (let i = 0; i < this.dataa.length; i++) {
            this.displayedColumns.push('column' + i);
        }
    }

    changeChkState(id) {
        this.items.forEach((chk) => {
            if (chk.id === id) {
                chk.checked = !chk.checked;
                this.getCheckbox();
            }
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        const {dataa} = changes;
        if (dataa.currentValue !== dataa.previousValue) {
            this.checkLan();
            if ((this.dataa[0]?.national || '') != 'TUN') {
                this.dataColumns.forEach((element, index) => {
                    if (element == 'cnssId') {
                        this.dataColumns.splice(index, 1);
                    }
                });

                this.labels.forEach((element, index) => {
                    if (element == 'N° Affiliation La C.N.S.S.') {
                        this.labels.splice(index, 1);
                    }
                });
            }
            this.getInfopGDetails();
        }
    }

    getCheckbox() {
        this.checked = this.items.filter((i) => i.checked == true);
    }

    getlang() {
        return this.apptranstlte.getDefaultLang();
    }

    checkLan() {
        if (this.getlang() == 'fr') {
            this.dataColumns = [
                'corporationClFr',
                'bizRegNo',
                'bizRegYmd',
                // "cnssId",
                'supplierNm',
                'commercialNm',
                'nationalFr',
                'openYmd',
                'select',
                'supplierClFr',
                'capitalAmt',
                'employeeNum',
                'postCd',
                'addr1',
                'addr2',
                'telNo',
                'faxNo',
                'hpage',
                'regReplyEmail',
            ];
        }
        if (this.getlang() == 'ar') {
            this.dataColumns = [
                'corporationClAr',
                'bizRegNo',
                'bizRegYmd',
                // "cnssId",
                'supplierNm',
                'commercialNm',
                'nationalAr',
                'openYmd',
                'select',
                'supplierClAr',
                'capitalAmt',
                'employeeNum',
                'postCd',
                'addr1',
                'addr2',
                'telNo',
                'faxNo',
                'hpage',
                'regReplyEmail',
            ];
        }
        if (this.getlang() == 'en') {
            this.dataColumns = [
                'corporationClEn',
                'bizRegNo',
                'bizRegYmd',
                // "cnssId",
                'supplierNm',
                'commercialNm',
                'nationalEn',
                'openYmd',
                'select',
                'supplierClEn',
                'capitalAmt',
                'employeeNum',
                'postCd',
                'addr1',
                'addr2',
                'telNo',
                'faxNo',
                'hpage',
                'regReplyEmail',
            ];
        }
    }
}
